
import { useState,useEffect } from 'react';
import styled from 'styled-components';

const MyImage = ({ imgs,main}) => {
  const { front,back, side, top, bottom, packaging } = imgs;
  const[mainImage,setMainImage]=useState(main);
  
  useEffect(() => {
    // Update main image whenever the `main` prop changes (e.g., new SKU selected)
    setMainImage(main);
    }, [main]);


    if (!imgs) {
      return <p>No images available</p>;
      }

  return (

    <Wrapper>
     <div className="myImages">
       <div className="differentView">
            {front && (
              <figure>
                <img src={front} alt="Front View" className="box-image--style"
                  onClick={() => setMainImage(front)}
                />
              </figure>
            )}
            {back && (
              <figure>
                <img src={back} alt="Back View" className="box-image--style"
                  onClick={() => setMainImage(back)}
                />
              </figure>
            )}
            {side && (
              <figure>
                <img src={side} alt="Side View" className="box-image--style"
                  onClick={() => setMainImage(side)}
                />
              </figure>
            )}
            {top && (
              <figure>
                <img src={top} alt="Top View" className="box-image--style"
                  onClick={() => setMainImage(top)}
                />
              </figure>
            )}
            {bottom && (
              <figure>
                <img src={bottom} alt="Bottom View" className="box-image--style"
                  onClick={() => setMainImage(bottom)}
                />
              </figure>
            )}
            {packaging && (
              <figure>
                <img src={packaging} alt="Packaging View" className="box-image--style"
                  onClick={() => setMainImage(packaging)}
                />
              </figure>
            )}
          </div>
        </div>
      <div className="main-screen">
        <img src={mainImage} alt="Main Image" />
      </div>
      
     
       
        </Wrapper >
        
  )
}
const Wrapper = styled.section`
  display: grid;
  grid-template-columns: 3fr 7fr;
  gap: 1rem;

.myImages{
  display: flex;              
  flex-direction: column;   
  justify-content: center;    
  align-items: center; 
   
  }
  
.differentView{
    display: flex;
    flex-direction: column;
    gap: 1rem; 
    
    
    img {
    max-width: 90%;
    max-height: 90%;
    object-fit: contain;
    cursor: pointer;
    box-shadow: ${({ theme }) => theme.colors.shadow};
    }
   }

.main-screen {
  display: grid;
  place-items: center;
  
  img {
    max-width: 100%;
    height: auto;
   }
  }
  


@media (max-width: ${({ theme }) => theme.media.mobile}) {
  display : flex;
  flex-direction : column;
  
  .myImages{
    order: 2;
  
    .differentView{
    display : flex;
    flex-direction : row;
    }
  }

  .main-screen {
  order:1;
  }
}

`;

export default MyImage
